import { __awaiter, __generator } from "tslib";
export function getXAnchorMailbox(searchSettings) {
    return __awaiter(this, void 0, void 0, function () {
        var identity, puid, tenantId, userPrincipalName;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, searchSettings.getIdentity()];
                case 1:
                    identity = _a.sent();
                    puid = identity.puid, tenantId = identity.tenantId, userPrincipalName = identity.userPrincipalName;
                    if (puid && tenantId) {
                        return [2 /*return*/, "PUID:".concat(puid, "@").concat(tenantId)];
                    }
                    return [2 /*return*/, userPrincipalName];
            }
        });
    });
}
//# sourceMappingURL=getXAnchorMailbox.js.map